import React from "react";
import PropTypes from "prop-types";
import { Container, Grid, Divider, Box } from "@material-ui/core";
import "./custom.css"
import "./layout.css"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import ScrollAnimation from 'react-animate-on-scroll';
import showdown from 'showdown';
import { Element } from 'react-scroll';
import { Link } from "gatsby";

import backgroundAboutImage from "../img/logolgbg2.png"

export default function AboutSection(props){

const converter = new showdown.Converter();

  const {
    heading,
    description,
    image
  } = props;


  const aboutImage = getImage(image)

  return (
    <Element name="about-section">
      <section className="aboutBackgroundImage" style={{backgroundImage: `url(${backgroundAboutImage})` }}>
        <ScrollAnimation animateIn="fadeIn">
          <Container maxWidth="md">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} className="sectionHeaderCenter">
                <h2>{heading}</h2>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={12} md={9} >
                <div className="bodyText" dangerouslySetInnerHTML={{ __html: converter.makeHtml(description) }} />
                <Link to="/currenthighsheriff" className="bodyLink">
                  Read More
                </Link>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <Box className="aboutImageContainer">
                  <GatsbyImage placeholder="blurred" image={aboutImage} alt={"High Sheriff of County Down - Prof Mike Mawhinney MBE TD"} className="aboutImage" />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </ScrollAnimation>
      </section>
    </Element>
  );
};

AboutSection.propTypes = {
props: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      subHeading: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};

